<div class="container-fluid cld-full-height cld-full-width-rectangle">
    <div class="section cld-full-height">
        <div class="">
            <div class="forgot-password-div">
                <mat-card class="pt-3 pr-5 pb-4 pl-5 solid-bg height-fit-content">
                    <div class="align-item-center">
                        <img class="pb-4 img-css" src="assets/new-icons/Spendkey_logo_dark.svg">
                    </div>
                    <div class="row mb-4">
                        <div class="col-12 align-center login-subheading">
                            <span class="txt-font-family-forgot-pwd">{{ 'Forgot Password' | translate }}</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12">
                            <form #forgotpass="ngForm" [formGroup]="userFormGroup" (ngSubmit)="sendRecoveryLink()">
                                <div class="align-txt"><span class="txt-recovery-font"> {{ 'We\'ll send a recovery link to' | translate }}</span></div>
                                <div class="form-group">
                                    <div class="input-group">
                                        <span class="spendkey-Email align-in-input"></span>
                                        <input type="text" formControlName="userEmail" class="form-control input-text"
                                            [placeholder]="'Work Email' | translate"
                                            [ngClass]="{ 'is-invalid':submitted && userFormGroup.controls['userEmail'].errors }" />
                                        <div *ngIf="submitted && userFormGroup.controls['userEmail'].errors"
                                            class="invalid-feedback bg-color login-error">
                                            <div style="font-size: 11px;" *ngIf="submitted && userFormGroup.controls['userEmail'].errors?.['required']">
                                                {{ 'This is required field!' | translate }}
                                            </div>
                                            <div style="font-size: 11px;" *ngIf="submitted && userFormGroup.controls['userEmail'].errors?.['email']">
                                                {{ 'Please enter valid email!' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button mat-stroked-button type="submit" style="width: 100%;"
                                    class=" mb-2 mt-2 sendkey-primary">
                                    {{ 'Send recovery link' | translate }}</button>
                            </form>
                        </div>
                    </div>
                    <div class="row pt-4 mt-3 border-top">
                        <div class="col-12 align-item-center">
                            <a routerLink="/login"><span class="txt-font-family-sign-in">{{ 'Return to log in' | translate }}</span></a>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</div>